import {
  Accordion,
  ActionIcon,
  Anchor,
  Blockquote,
  CopyButton,
  Group,
  Stack,
  Switch,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useMemo, useState } from "react";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { useSessionStore } from "../../../../../stores/UserStore";
import { appHost } from "../../../../../functions/appHost";

const ApiKeyUse = ({ apiProfile }) => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  const token = apiProfile.token;

  const [letPageChange, setLetPageChange] = useState(false);
  const [letTabChange, setLetTabChange] = useState(false);
  const [allowSwitch, setAllowSwitch] = useState(false);
  const [disableNav, setDisableNav] = useState(false);
  const [disableHeading, setDisableHeading] = useState(false);
  const [disableActions, setDisableActions] = useState(false);
  const [disableSelection, setDisableSelection] = useState(false);
  const [disableMobileDetect, setDisableMobileDetect] = useState(false);

  const apiKeyPages = useMemo(
    () => [
      {
        group: lang.api_keys.uses.lists.group_name,
        parent: "/contact-lists",
        values: [
          {
            name: lang.api_keys.uses.lists.group_name,
            value: "/none",
            isList: true,
          },
        ],
      },
      {
        group: lang.api_keys.uses.models.group_name,
        parent: "/models",
        values: [
          // {
          //   name: lang.api_keys.uses.models.folders,
          //   value: "/folder",
          //   isFolder: true,
          //   type: "Model",
          // },
          {
            name: lang.api_keys.uses.models.emails,
            value: "/email/none",
          },
          {
            name: lang.api_keys.uses.models.linkedin_invitations,
            value: "/linkedin-invitation/none",
          },
          {
            name: lang.api_keys.uses.models.linkedin_messages,
            value: "/linkedin-message/none",
          },
          {
            name: lang.api_keys.uses.models.sms,
            value: "/sms/none",
          },
          {
            name: lang.api_keys.uses.models.smv,
            value: "/smv/none",
          },
          {
            name: lang.api_keys.uses.models.forms,
            value: "/forms",
          },
        ],
      },
      {
        group: lang.api_keys.uses.senders.group_name,
        parent: "/senders",
        values: [
          {
            name: lang.api_keys.uses.senders.emails,
            value: "/email/none",
          },
          {
            name: lang.api_keys.uses.senders.email_pools,
            value: "/pool/none/email/none",
          },
          {
            name: "LinkedIn",
            value: "/linkedin/none",
          },
        ],
      },
      {
        group: lang.api_keys.uses.stats.group_name,
        parent: "/statistics",
        values: [
          {
            name: lang.api_keys.uses.workflow.group_name,
            value: "/campaigns/workflows",
          },
          {
            name: lang.api_keys.uses.stats.campaigns,
            value: "/campaigns/running",
          },
        ],
      },
      {
        group: lang.api_keys.uses.prm.group_name,
        parent: "/leads-tracking",
        values: [
          {
            name: lang.api_keys.uses.prm.main,
            value: "/",
          },
        ],
      },
      {
        group: "Reporting",
        parent: "/reporting",
        values: [
          {
            name: "Reporting",
            value: "",
          },
        ],
      },
    ],
    [lang]
  );

  const value = useMemo(() => {
    let pageChangeValue = letPageChange ? "true" : "false";
    let tabChangeValue = letTabChange ? "true" : "false";
    let navValue = disableNav ? "true" : "false";
    let headingValue = disableHeading ? "true" : "false";
    let actionsValue = disableActions ? "true" : "false";
    let selectionValue = disableSelection ? "true" : "false";
    let switchValue = allowSwitch ? "true" : "false";
    let mobileValue = disableMobileDetect ? "true" : "false";

    return `?apiKey=${token}&disableNav=${navValue}&navigator=${tabChangeValue}&disableHeading=${headingValue}&disableActions=${actionsValue}&disableMobile=${mobileValue}&disableSelection=${selectionValue}&allowSwitch=${switchValue}&activate=${pageChangeValue}`;
  }, [
    letPageChange,
    letTabChange,
    disableNav,
    disableHeading,
    disableActions,
    disableSelection,
    disableMobileDetect,
    allowSwitch,
    token,
  ]);

  return (
    <Stack
      gap={"xs"}
      py={"lg"}
      flex={"1 1 auto"}
      h={0}
      style={{ overflow: "auto" }}
      mih={"100%"}
      pt={"xs"}
    >
      <Text size="md">{lang.api_keys.uses_dialog.text}</Text>

      <Group gap={"lg"} my={"xs"}>
        <Switch
          checked={letPageChange}
          size="sm"
          onChange={(e) => setLetPageChange(e.target.checked)}
          color="green"
          label={lang.api_keys.uses_dialog.page_change}
          w={"45%"}
        />
        <Switch
          checked={letTabChange}
          size="sm"
          onChange={(e) => {
            if (e.target.checked) {
              setLetPageChange(true)
            }
            setLetTabChange(e.target.checked)
          }}
          color="green"
          label={lang.api_keys.uses_dialog.tab_change}
        />
        <Switch
          checked={disableNav}
          size="sm"
          onChange={(e) => setDisableNav(e.target.checked)}
          color="red"
          label={lang.api_keys.uses_dialog.disable_header}
          w={"45%"}
        />
        <Switch
          checked={disableHeading}
          size="sm"
          onChange={(e) => setDisableHeading(e.target.checked)}
          color="red"
          label={lang.api_keys.uses_dialog.disable_heading}
          w={"45%"}
        />
        <Switch
          checked={disableActions}
          size="sm"
          onChange={(e) => setDisableActions(e.target.checked)}
          color="red"
          label={lang.api_keys.uses_dialog.disable_actions}
          w={"45%"}
        />
        <Switch
          checked={disableSelection}
          size="sm"
          onChange={(e) => setDisableSelection(e.target.checked)}
          color="red"
          label={lang.api_keys.uses_dialog.disable_selections}
          w={"45%"}
        />
        <Switch
          checked={disableMobileDetect}
          size="sm"
          onChange={(e) => setDisableMobileDetect(e.target.checked)}
          color="red"
          label={lang.api_keys.uses_dialog.disable_mobile_detect}
          w={"45%"}
        />
        <Switch
          checked={allowSwitch}
          size="sm"
          onChange={(e) => setAllowSwitch(e.target.checked)}
          color="red"
          label={lang.api_keys.uses_dialog.allow_switch}
          w={"45%"}
        />
      </Group>
      <Text size="sm">
        {lang.api_keys.uses_dialog.text1}{" "}
        <b>{lang.api_keys.uses_dialog.text2}</b>
      </Text>

      <TextInput
        w={"100%"}
        value={value}
        size="md"
        readOnly
        leftSection={
          <Text>
            https://{appHost(reseller)}/
          </Text>
        }
        leftSectionWidth={240}
        rightSection={
          <CopyButton
            value={`https://${appHost(reseller)}/${value}`}
          >
            {({ copied, copy }) => (
              <Tooltip
                label={copied ? lang.global.copied : lang.global.copy}
                color={copied ? "green" : "black"}
              >
                <ActionIcon
                  size={"lg"}
                  variant="light"
                  color={copied ? "green" : "primary"}
                  onClick={copy}
                >
                  {copied ? <IconCheck size={20} /> : <IconCopy size={20} />}
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
        }
      />

      <Blockquote color="secondary" radius={"md"} py={"xs"} pl={"lg"} mt={16}>
        <Stack gap={0}>
          <Group gap={4}>
            <Text>{lang.api_keys.clear_text}</Text>
            <CopyButton value={`?clearAll=true`}>
              {({ copied, copy }) => (
                <Tooltip
                  label={copied ? lang.global.copied : lang.global.copy}
                  color={copied ? "green" : "black"}
                >
                  <Anchor fw={600} onClick={copy} truncate="end">
                    ?clearAll=true
                  </Anchor>
                </Tooltip>
              )}
            </CopyButton>
            <Text>{lang.api_keys.clear_text2}</Text>
          </Group>

          <Text c={"dimmed"}>
            Ex: https://{appHost(reseller)}?clearAll=true
          </Text>
        </Stack>
      </Blockquote>

      <Text fw={500} mt={16}>
        {lang.api_keys.uses_dialog.examples}
      </Text>

      <Accordion defaultValue={"contact-lists"} variant="contained">
        {apiKeyPages.map((page) => (
          <Accordion.Item key={page.group} value={page.group}>
            <Accordion.Control>{page.group}</Accordion.Control>
            <Accordion.Panel>
              {page.values.map((item) => (
                <Stack key={item.value}>
                  <Group mb={"sm"}>
                    <TextInput
                      key={item.value}
                      value={`https://${appHost(reseller)}${page.parent}${item.value}${value}`}
                      label={item.name}
                      readOnly
                      w={"100%"}
                      size="md"
                      rightSectionWidth={64}
                      rightSection={
                        <CopyButton
                          value={`https://${appHost(reseller)}${page.parent}${item.value}${value}`}
                        >
                          {({ copied, copy }) => (
                            <Tooltip
                              label={
                                copied ? lang.global.copied : lang.global.copy
                              }
                              color={copied ? "green" : "black"}
                            >
                              <ActionIcon
                                size={"lg"}
                                variant="light"
                                color={copied ? "green" : "primary"}
                                onClick={copy}
                              >
                                {copied ? (
                                  <IconCheck size={20} />
                                ) : (
                                  <IconCopy size={20} />
                                )}
                              </ActionIcon>
                            </Tooltip>
                          )}
                        </CopyButton>
                      }
                    />
                  </Group>
                </Stack>
              ))}
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </Stack>
  );
};

export default ApiKeyUse;
